import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import SearchFieldWithDropdown from "components/common/custom/forms/SearchPatientWithDropDown";
import MultiSelect from "components/common/MultiSelect";
import {
  GetAllPoyer,
  GetPayerInsurance,
} from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import { GetAllIdentifierType } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import React, { useEffect } from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllPreauthorizationStatus,
  GetAllPreauthorizationType,
} from "../config/preauthorizationApi";
import { ArrowRepeat, Chat, Shield } from "react-bootstrap-icons";
import { handlePreauthorizationFilter } from "../config/preauthorizationSlice";
import SearchPreauthorizationPatient from "./SearchPreauthorizationPatient";

const PreauthorizationListFilter = ({
  onSubmit,
  control,
  watch,
  setValue,
  resetTrigger,
}) => {
  const dispatch = useDispatch();
  const { poyerList, payerInsurance } = useSelector(
    (state) => state.eligibilityCheckList
  );
  const payer = watch("payer");
  const { identifierTypeList } = useSelector((state) => state.eligibilityCheck);
  const {
    preauthorizationType,
    preauthorizationSubType,
    preauthorizationFilters,
    preauthorizationStatus,
  } = useSelector((state) => state.preauthorization);
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
    if (preauthorizationType?.length === 0) {
      dispatch(GetAllPreauthorizationType());
    }
    if (identifierTypeList?.length === 0) {
      dispatch(GetAllIdentifierType());
    }
    if (preauthorizationStatus?.length === 0) {
      dispatch(GetAllPreauthorizationStatus());
    }
  }, []);

  useEffect(() => {
    setValue("payer", preauthorizationFilters?.payer);
    setValue("insurance", preauthorizationFilters?.insurance);
    setValue("start_date", preauthorizationFilters?.start_date);
    setValue("end_date", preauthorizationFilters?.end_date);
    setValue("reference_no_ref", preauthorizationFilters?.reference_number);
    setValue(
      "preauthorization_type",
      preauthorizationFilters?.preauthorization_type
    );
    setValue(
      "preauthorization_sub_type",
      preauthorizationFilters?.preauthorization_sub_type
    );
    setValue("identity_type", preauthorizationFilters?.identity_type);
    setValue("identity_number", preauthorizationFilters?.identity_number);
    setValue(
      "preauth_status",
      preauthorizationFilters?.preauthorization_status
    );

    setValue("second_response", preauthorizationFilters?.secondary_response);
    setValue("communication", preauthorizationFilters?.communication);
    setValue(
      "advance_preauthorization",
      preauthorizationFilters?.advanced_authorization
    );
  }, []);

  useEffect(() => {
    if (payer) {
      const body = { payer_id: payer?.payer_id };
      dispatch(GetPayerInsurance(body));
    }
  }, [payer]);

  const handlePayer = (selected) => {
    if (!selected) {
      setValue("payer", null);
      setValue("insurance", null);
      dispatch(handlePreauthorizationFilter({ check: "payer", value: null }));
      dispatch(
        handlePreauthorizationFilter({
          check: "insurance",
          value: null,
        })
      );
      return;
    }

    const value = {
      payer_name: selected.label,
      payer_id: selected.value,
    };
    setValue("payer", value);
    dispatch(handlePreauthorizationFilter({ check: "payer", value }));
  };

  const handleInsurance = (selected) => {
    if (!selected) {
      setValue("insurance", null);
      dispatch(
        handlePreauthorizationFilter({
          check: "insurance",
          value: null,
        })
      );
      return;
    }

    const value = {
      insurance_company_name: selected.label,
      insurance_company_id: selected.value,
    };
    setValue("insurance", value);
    dispatch(handlePreauthorizationFilter({ check: "insurance", value }));
  };

  const handleStartDate = (selected) => {
    setValue("start_date", selected);

    dispatch(
      handlePreauthorizationFilter({
        check: "start_date",
        value: selected,
      })
    );
  };
  const handleEndDate = (selected) => {
    setValue("end_date", selected);

    dispatch(
      handlePreauthorizationFilter({
        check: "end_date",
        value: selected,
      })
    );
  };

  const handleReferenceNumber = (value) => {
    setValue("reference_no_ref", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "reference_number",
        value,
      })
    );
  };
  const handlePreauthID = (value) => {
    setValue("preauthid", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "preauthid",
        value,
      })
    );
  };
  const handleIdentityNumber = (value) => {
    setValue("identity_number", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "identity_number",
        value,
      })
    );
  };

  const handlePreauthType = (selected) => {
    if (!selected) {
      setValue("preauthorization_type", null);
      dispatch(
        handlePreauthorizationFilter({
          check: "preauthorization_type",
          value: null,
        })
      );
      return;
    }

    const value = {
      claim_types_name: selected.label,
      claim_types_id: selected.value,
    };
    setValue("preauthorization_type", value);
    dispatch(
      handlePreauthorizationFilter({ check: "preauthorization_type", value })
    );
  };
  const handlePreauthSubType = (selected) => {
    if (!selected) {
      setValue("preauthorization_sub_type", null);
      dispatch(
        handlePreauthorizationFilter({
          check: "preauthorization_sub_type",
          value: null,
        })
      );
      return;
    }

    const value = {
      claimsub_types_name: selected.label,
      claimsub_types_id: selected.value,
    };
    setValue("preauthorization_sub_type", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "preauthorization_sub_type",
        value,
      })
    );
  };
  const handleIdentityType = (selected) => {
    if (!selected) {
      setValue("identity_type", null);
      dispatch(
        handlePreauthorizationFilter({
          check: "identity_type",
          value: null,
        })
      );
      return;
    }

    const value = {
      ident_type_name: selected.label,
      ident_type_id: selected.value,
    };
    setValue("identity_type", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "identity_type",
        value,
      })
    );
  };

  const handlePreauthorizationStatus = (selected) => {
    if (!selected) {
      setValue("preauth_status", null);
      dispatch(
        handlePreauthorizationFilter({
          check: "preauthorization_status",
          value: null,
        })
      );
      return;
    }

    const value = {
      allstatus_name: selected.label,
      allstatus_code: selected.value,
    };
    setValue("preauth_status", value);
    dispatch(
      handlePreauthorizationFilter({
        check: "preauthorization_status",
        value,
      })
    );
  };

  const handleSecondResponse = (value) => {
    dispatch(
      handlePreauthorizationFilter({
        check: "secondary_response",
        value,
      })
    );
  };

  const handleCommunication = (value) => {
    dispatch(
      handlePreauthorizationFilter({
        check: "communication",
        value,
      })
    );
  };

  const handleAdvancePreauthorization = (value) => {
    dispatch(
      handlePreauthorizationFilter({
        check: "advanced_authorization",
        value,
      })
    );
  };

  return (
    <div className="p-0">
      <Row className="align-items-center">
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="payer">
            <Form.Label>Payer</Form.Label>
            <Controller
              name="payer"
              control={control}
              render={({ field }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    size="sm"
                    options={poyerList?.map((poyer) => ({
                      value: poyer.payer_id,
                      label: poyer.payer_name,
                    }))}
                    isClearable={true}
                    placeholder="Choose..."
                    value={
                      field.value
                        ? {
                          value: field.value.payer_id,
                          label: field.value.payer_name,
                        }
                        : null
                    }
                    onChange={(selected) => handlePayer(selected)}
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="insurance">
            <Form.Label>Insurance</Form.Label>
            <Controller
              name="insurance"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isClearable={true}
                    isMulti={false}
                    size="sm"
                    options={payerInsurance?.map((poyer) => ({
                      value: poyer.insurance_company_id,
                      label: poyer.insurance_company_name,
                    }))}
                    placeholder="Choose..."
                    className={error ? "is-invalid" : ""}
                    value={
                      field.value
                        ? {
                          value: field.value.insurance_company_id,
                          label: field.value.insurance_company_name,
                        }
                        : null
                    }
                    onChange={(selected) => handleInsurance(selected)}
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <SearchPreauthorizationPatient
          resetTrigger={resetTrigger}
          setValue={setValue}
        />
        <Col xs={12} sm={6} md={3} xl={2}>
          <BootDatePicker
            name="start_date"
            label="Start Date"
            size="sm"
            control={control}
            selected={watch("start_date")}
            onChange={(date) => handleStartDate(date)}
            placeholder="dd/mm/yyyy"
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <BootDatePicker
            name="end_date"
            label="End Date"
            size="sm"
            control={control}
            selected={watch("end_date")}
            onChange={(date) => handleEndDate(date)}
            placeholder="dd/mm/yyyy"
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="reference_no_ref"
            label="Reference Number "
            size="sm"
            onChange={(selected) => handleReferenceNumber(selected)}
            control={control}
            placeholder="PreAuth Ref No"
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="preauthid"
            label="Preauthorization ID"
            size="sm"
            onChange={(selected) => handlePreauthID(selected)}
            control={control}
            placeholder="PreAuth Ref No"
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="preauthorization_type">
            <Form.Label>PreAutherization Type</Form.Label>
            <Controller
              name="preauthorization_type"
              control={control}
              render={({ field }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    size="sm"
                    options={preauthorizationType?.map((item) => ({
                      value: item?.claim_types_id,
                      label: item?.claim_types_name,
                    }))}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                          value: field.value.claim_types_id,
                          label: field.value.claim_types_name,
                        }
                        : null
                    }
                    onChange={(selected) => handlePreauthType(selected)}
                    placeholder="Choose..."
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="preauthorization_sub_type">
            <Form.Label>PreAutherization Sub Type</Form.Label>
            <Controller
              name="preauthorization_sub_type"
              control={control}
              render={({ field }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    size="sm"
                    options={preauthorizationSubType?.map((item) => ({
                      value: item?.claimsub_types_id,
                      label: item?.claimsub_types_name,
                    }))}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                          value: field.value.claimsub_types_id,
                          label: field.value.claimsub_types_name,
                        }
                        : null
                    }
                    onChange={(selected) => handlePreauthSubType(selected)}
                    placeholder="Choose..."
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Identity Type</label>
          <Controller
            name="identity_type"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={identifierTypeList?.map((item) => ({
                  value: item.ident_type_id,
                  label: item.ident_type_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                      value: field.value.ident_type_id,
                      label: field.value.ident_type_name,
                    }
                    : null
                }
                onChange={(selected) => handleIdentityType(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        {/* <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="identity_number"
            onChange={(value) => handleIdentityNumber(value)}
            label="Identity Number"
            size="sm"
            control={control}
            placeholder="Identity Number"
          />
        </Col> */}
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Label>Preauth Status</Form.Label>
          <Controller
            name="preauth_status"
            control={control}
            render={({ field }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  options={preauthorizationStatus?.map((item) => ({
                    value: item?.allstatus_code,
                    label: item?.allstatus_name,
                  }))}
                  isClearable={true}
                  value={
                    field.value
                      ? {
                        value: field.value.allstatus_code,
                        label: field.value.allstatus_name,
                      }
                      : null
                  }
                  onChange={(selected) =>
                    handlePreauthorizationStatus(selected)
                  }
                  placeholder="Choose..."
                />
              </>
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Row className="mt-4">
            {/* Second Response */}
            <Col xs={4}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    style={{
                      "--bs-tooltip-bg": "var(--bs-success)",
                      "--bs-tooltip-color": "var(--bs-white)",
                    }}
                    className="rounded"
                  >
                    Second Response
                  </Tooltip>
                }
              >
                <div>
                  <Controller
                    name="second_response"
                    control={control}
                    render={({ field }) => (
                      <div
                        className={`border d-flex cursor-pointer py-x justify-content-center gap-2 align-items-center rounded ${field.value
                          ? "badge-subtle-success border-success"
                          : "border"
                          }`}
                        onClick={() => {
                          const newValue = !field.value;
                          field.onChange(newValue);
                          handleSecondResponse(newValue);
                        }}
                        style={{ userSelect: "none" }}
                      >
                        <ArrowRepeat className="ms-2" />
                        {field.value ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 512 512"
                          >
                            <path
                              d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                              fill="#00894f"
                            />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 512 512">
                            <circle
                              cx="256"
                              cy="256"
                              r="216"
                              stroke="#bcbcbc"
                              strokeWidth="40"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  />
                </div>
              </OverlayTrigger>
            </Col>

            {/* Communication */}
            <Col xs={4}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    style={{
                      "--bs-tooltip-bg": "var(--bs-warning)",
                      "--bs-tooltip-color": "var(--bs-black)",
                    }}
                    className="rounded"
                  >
                    Communication
                  </Tooltip>
                }
              >
                <div>
                  <Controller
                    name="communication"
                    control={control}
                    render={({ field }) => (
                      <div
                        className={`border d-flex cursor-pointer py-x justify-content-center gap-2 align-items-center rounded ${field.value
                          ? "badge-subtle-warning border-warning"
                          : "border"
                          }`}
                        onClick={() => {
                          const newValue = !field.value;
                          field.onChange(newValue);
                          handleCommunication(newValue);
                        }}
                        style={{ userSelect: "none" }}
                      >
                        <Chat className="ms-2" />
                        {field.value ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 512 512"
                          >
                            <path
                              d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                              fill="#f4a100"
                            />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 512 512">
                            <circle
                              cx="256"
                              cy="256"
                              r="216"
                              stroke="#bcbcbc"
                              strokeWidth="40"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  />
                </div>
              </OverlayTrigger>
            </Col>

            {/* Advanced Authorization */}
            <Col xs={4}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    style={{
                      "--bs-tooltip-bg": "var(--bs-primary)",
                      "--bs-tooltip-color": "var(--bs-white)",
                    }}
                    className="rounded"
                  >
                    Advanced Authorization
                  </Tooltip>
                }
              >
                <div>
                  <Controller
                    name="advance_preauthorization"
                    control={control}
                    render={({ field }) => (
                      <div
                        className={`border d-flex cursor-pointer py-x justify-content-center gap-2 align-items-center rounded ${field.value
                          ? "badge-subtle-primary border-primary"
                          : "border"
                          }`}
                        onClick={() => {
                          const newValue = !field.value;
                          field.onChange(newValue);
                          handleAdvancePreauthorization(newValue);
                        }}
                        style={{ userSelect: "none" }}
                      >
                        <Shield className="ms-2" />
                        {field.value ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 512 512"
                          >
                            <path
                              d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                              fill="#084298"
                            />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 512 512">
                            <circle
                              cx="256"
                              cy="256"
                              r="216"
                              stroke="#bcbcbc"
                              strokeWidth="40"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  />
                </div>
              </OverlayTrigger>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PreauthorizationListFilter;
